import { Button } from '@pfida-finance/ui/components';

import { showCookieSettings } from '@/libs/hubspotConsent';

// Legal asks for a way to change the cookie choice from every page
export function CookieSettingsLink() {
  return (
    <Button variant="outline" size="sm" onClick={showCookieSettings} className="fixed bottom-3 left-3 z-50 shadow-sm">
      Cookie settings
    </Button>
  );
}
